import { useEffect, useSyncExternalStore } from 'react';
const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function findDarkSchemeQuery() {
    let darkSchemeQuery;
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
        darkSchemeQuery = window.matchMedia(DARK_SCHEME_QUERY);
    }
    return darkSchemeQuery;
}
function subscribeToSchemeChanges(onSchemeChange) {
    const darkSchemeQuery = findDarkSchemeQuery();
    darkSchemeQuery?.addEventListener('change', onSchemeChange);
    return () => darkSchemeQuery?.removeEventListener('change', onSchemeChange);
}
function readSystemTheme() {
    return findDarkSchemeQuery()?.matches === true ? 'dark' : 'light';
}
function readServerTheme() {
    return 'light';
}
/**
 * The system's light or dark setting, following changes live; `light` when it cannot be read (no `matchMedia`, or
 * rendering outside a browser). While mounted it also marks the document root, so the page background, scrollbars
 * and overscroll area follow the theme, not only the wrapped content.
 */
export function useSystemTheme() {
    const theme = useSyncExternalStore(subscribeToSchemeChanges, readSystemTheme, readServerTheme);
    useEffect(() => {
        const documentRoot = document.documentElement;
        documentRoot.setAttribute('data-theme', theme);
        return () => documentRoot.removeAttribute('data-theme');
    }, [theme]);
    return theme;
}
//# sourceMappingURL=useSystemTheme.js.map